import { RuleId } from '@wix/a11y-rules';
import { normalizeKeyForColorContrastCrossIssue } from '@wix/a11y-wizard-common';
export const getSpecificPageIssueResults = (executionResults, crossPageIssues, crossPageColorContrastIssuesInSession) => {
  const {
    crossPagesHeadingStructureIssues,
    crossPagesColorContrastIssues
  } = crossPageIssues;
  const specificPageResults = [];
  const ruleHandlers = {
    [RuleId.VALID_STATIC_PAGE_TITLE]: results => results,
    [RuleId.HEADING_STRUCTURE]: results => crossPagesHeadingStructureIssues ? [] : results,
    [RuleId.COLOR_CONTRAST]: results => results.map(result => {
      var _result$metadata, _crossPageResult$resu, _result$result, _result$result2;
      if (!((_result$metadata = result.metadata) != null && _result$metadata.breakpointId) || !(crossPagesColorContrastIssues != null && crossPagesColorContrastIssues[result.metadata.breakpointId])) {
        return result;
      }
      const crossPageResult = crossPagesColorContrastIssues[result.metadata.breakpointId];
      const crossPageElementKeys = new Set([...crossPageColorContrastIssuesInSession, ...(((_crossPageResult$resu = crossPageResult.result) == null || (_crossPageResult$resu = _crossPageResult$resu.failedElements) == null ? void 0 : _crossPageResult$resu.map(element => normalizeKeyForColorContrastCrossIssue(element))) || [])]);
      const originalElements = ((_result$result = result.result) == null ? void 0 : _result$result.failedElements) || [];
      const newFailedElements = originalElements.filter(element => !crossPageElementKeys.has(normalizeKeyForColorContrastCrossIssue(element))) || [];
      return {
        ...result,
        result: {
          ...result.result,
          failedElements: newFailedElements,
          status: newFailedElements.length === 0 ? 'passed' : (_result$result2 = result.result) == null ? void 0 : _result$result2.status
        }
      };
    }),
    [RuleId.STATIC_ALT_TEXT]: () => [],
    [RuleId.MEDIA_ALTERNATIVES]: () => [],
    [RuleId.INACCESSIBLE_COMPONENTS]: () => []
  };
  Object.values(executionResults).forEach(ruleDict => {
    for (const [ruleId, ruleResults] of Object.entries(ruleDict)) {
      const typedRuleId = ruleId;
      const handler = ruleHandlers[typedRuleId];
      if (handler) {
        specificPageResults.push(...handler(ruleResults));
      }
    }
  });
  const filteredResults = specificPageResults.filter(result => {
    var _result$result3;
    return ((_result$result3 = result.result) == null ? void 0 : _result$result3.status) !== 'error';
  });
  return filteredResults;
};
//# sourceMappingURL=get-specific-page-issue-results.js.map